import { Formik } from 'formik';
import { useCallback, useContext } from 'react';

import './VendorLeadStepPictures.scss';

import { vendorsApi } from 'src/app/services/Vendors/Vendors.service';
import {
  type IVendorLeadProductImagesFormValues,
  vendorLeadProductImagesInitialValues,
  vendorLeadProductImagesValidationSchema,
} from 'src/components/vendors/steps/Pictures/VendorLeadStepPictures.validation';
import { VendorLeadStepPicturesImageList } from 'src/components/vendors/steps/Pictures/VendorLeadStepPicturesImageList';
import { VendorLeadStepLayout } from 'src/components/vendors/steps/VendorLeadStepLayout';
import { getFilesDiff } from 'src/helpers';
import { VendorsContext } from 'src/pages/VendorsPage/VendorsPage.context';

type VendorLeadStepPicturesProps = {
  vendorProductLeadId: string;
};

export function VendorLeadStepPictures({ vendorProductLeadId }: Readonly<VendorLeadStepPicturesProps>) {
  const { vendorLeadProduct, updateVendorLeadProduct } = useContext(VendorsContext);

  const [, partialUpdateVendorProductLead] = vendorsApi.usePartialUpdateVendorProductLeadMutation(vendorProductLeadId);

  const handleSubmit = useCallback(
    async (values: IVendorLeadProductImagesFormValues) => {
      const updatedVendorProductLeadData = await partialUpdateVendorProductLead({
        data: {
          images: getFilesDiff(values.images, vendorLeadProduct?.images ?? []),
        },
      });

      updateVendorLeadProduct(updatedVendorProductLeadData.data);

      return true;
    },
    [partialUpdateVendorProductLead, vendorLeadProduct?.images, updateVendorLeadProduct]
  );

  return (
    <Formik<IVendorLeadProductImagesFormValues>
      initialValues={vendorLeadProductImagesInitialValues(vendorLeadProduct?.images ?? [])}
      validationSchema={vendorLeadProductImagesValidationSchema}
      validateOnMount={true}
      enableReinitialize={true}
      onSubmit={handleSubmit}
    >
      <VendorLeadStepLayout>
        <VendorLeadStepPicturesImageList />
      </VendorLeadStepLayout>
    </Formik>
  );
}
